module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof47-2"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "imgfr31",
      "src": "images/imgfr31.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Order of St. Andew on Common Uniform")])]), _vm._v(" "), _c('p', {
    staticClass: "para2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Order of St. Vladimir")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Orden Sv. Vladimira")]), _vm._v(") was established by Catherine the Great in 1782 on the twentieth anniversary of her reign. Named after prominent Prince Vladimir of Ancient Kiev, it became the second highest order in the Russian empire. The order had four classes and was awarded for distinguished military and civil service. During the Napoleonic Wars, 12 first class and 95 second class orders were awarded. Third and fourth classes were awarded frequently.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa684b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof47-2.vue
// module id = 240
// module chunks = 0